import { useUser } from "../../contexts/UserContext";
import WeeklyRegistrationsBox from "../../components/admin/RegCount";
import WeeklyPremiumBox from "../../components/admin/PaymentCount";
import AreaChart from "../../components/admin/AreaChart";

const Dashboard = () => {
  const { user, loading } = useUser();

  if (loading) return <p>Loading...</p>; // or a spinner
  if (!user) return <p>Not authenticated</p>; // or redirect

  return (
    <div>
      <h3>Welcome, {user.name}</h3>
      <div className="row mb-4">
        <div className="col-lg-3 col-6">
          <WeeklyRegistrationsBox />
        </div>
        <div className="col-lg-3 col-6">
          <WeeklyPremiumBox />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-6">
          <AreaChart />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
